import {
  MAXIMUM_HANDLE_INDEX,
  MINIMUM_HANDLE_INDEX,
} from 'src/components/molecules/RangeInput/constants/handles';
import type {
  AccessibleHandleLabels,
  HandleInputNames,
  RangeInputRanges,
} from 'src/components/molecules/RangeInput/types';
import type { Filter } from 'src/types';
import { STEP_BETWEEN_VALUES } from './constants/stepBetweenValues';

export interface RangeInputProperties {
  step: number;
  range: RangeInputRanges;
  handleLabels: AccessibleHandleLabels;
  handleInputNames: HandleInputNames;
}

export const getRangeInputProperties = (filter: Filter): RangeInputProperties => ({
  step: STEP_BETWEEN_VALUES,
  range: [
    filter.options[MINIMUM_HANDLE_INDEX].minValue!,
    filter.options[MAXIMUM_HANDLE_INDEX].maxValue!,
  ],
  handleLabels: {
    minimum: filter.options[MINIMUM_HANDLE_INDEX].title,
    maximum: filter.options[MAXIMUM_HANDLE_INDEX].title,
  },
  handleInputNames: {
    minimum: filter.options[MINIMUM_HANDLE_INDEX].uid!,
    maximum: filter.options[MAXIMUM_HANDLE_INDEX].uid!,
  },
});
